import { Modal, Box } from "@mui/material";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
  PieChart,
  Pie,
  Legend,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import whiteCharticon from "../../assets/icons/Prediction.png";
import charticon from "../../assets/icons/Path 23145.svg";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import { toTitleCase } from "../../helpers/TitleCase";
import {
  getPartyList,
  getUserPredictionById,
  resetPollFields,
  updateUserPrediction,
} from "../../redux/actions/pollingAction";
import { Helmet } from "react-helmet-async";
import { BASE_URL_PP } from "../../redux/api";
import SegmentComparisonChart from "./SegmentComparisonChart";

const MyPredictions = () => {
  const isVerified = localStorage.getItem("accessToken");
  const { UpdatePredictionResponse } = useSelector((state) => state?.pollWeb);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { updatePredictionStep } = useContext(PredictionContext);
  const params = useParams();
  const [tableData, setTableData] = useState([]);
  const [rowErrors, setRowErrors] = useState([]);
  const [availableComaprisions, setAvailableComaprisions] = useState({
    best: false,
    average: false,
  });

  const [compare, setCompare] = useState({
    show: false,
    payload: [],
  });
  const compareRef = useRef(null);
  const [iscompare, setIsCompare] = useState(false)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (compareRef.current && !compareRef.current.contains(event.target)) {
        setCompare((prev) => ({ ...prev, show: false }));
      }
    };

    if (compare.show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [compare.show]);

  const checkComaprisionsAvailability = async () => {
    try {
      const response = await fetch(
        `${BASE_URL_PP}user/user-prediction/view/${params?.id}?filter=copy-averages&filter=copy-best`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken") || ""
              }`,
          },
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        console.log("data", data);
        const best = data && data?.data?.bestPollster?.length > 0;
        // console.log("best", best);
        const average = data && data?.data?.averagePollster?.length > 0;
        // const hasData = data && (data?.best || data?.average);
        setAvailableComaprisions((prev) => ({
          ...prev,
          average: average,
          best: best,
        }));
      }
    } catch (error) {
      console.error(`Fetch error for ${"copy-averages"}:`, error);
      // setAvailableComaprisions((prev) => ({
      //   ...prev,
      //   average: false,
      // }));
    }
  };

  const { PartyListResponse, PredictionDetailResponse } = useSelector(
    (state) => state?.pollWeb
  );
  console.log("🚀 ~ MyPredictions ~ PredictionDetailResponse:", PredictionDetailResponse)
  const transformedVoteShareData =
    PredictionDetailResponse?.userPredictionVoteshares?.map((item) => ({
      name: item?.["party.abbreviation"]?.toUpperCase(),
      value: parseFloat(parseFloat(item?.values).toFixed(2)),
      color: item?.["party.color_code"],
    }));

  const transformedSegmentData =
    PredictionDetailResponse?.userPredictionSegment?.map((item) => ({
      name: item?.["party.abbreviation"]?.toUpperCase(),
      value: parseFloat(parseFloat(item?.values).toFixed(2)),
      color: item?.["party.color_code"],
      category: item?.["voterCategory.name"]?.toUpperCase(),
    }));

  const legendData = Array.from(
    new Map(
      transformedSegmentData
        ?.filter((d) => d.name && !d?.isGap)
        ?.map((d) => [d.name, { name: d.name, color: d.color }])
    ).values()
  );
  const voteShareLegendData = Array.from(
    new Map(
      transformedVoteShareData
        ?.filter((d) => d.name && !d?.isGap)
        ?.map((d) => [d.name, { name: d?.name, color: d?.color }])
    ).values()
  );

  const CustomLegend = () => (
    <div className="flex flex-wrap justify-center gap-6 text-sm mt-2">
      {legendData?.map((entry) => (
        <div key={entry.name} className="flex items-center gap-1">
          <div
            style={{
              width: 12,
              height: 12,
              backgroundColor: entry?.color,
              borderRadius: 20,
            }}
          />
          <span>{entry?.name}</span>
        </div>
      ))}
    </div>
  );
  const CustomVoteShareLegend = () => (
    <div className="flex flex-wrap justify-center gap-6 text-sm mt-2">
      {voteShareLegendData?.map((entry) => (
        <div key={entry.name} className="flex items-center gap-1">
          <div
            style={{
              width: 12,
              height: 12,
              backgroundColor: entry?.color,
              borderRadius: 20,
            }}
          />
          <span>{entry?.name}</span>
        </div>
      ))}
    </div>
  );

  const handleNewPrediction = () => {
    updatePredictionStep("newPrediction");
    navigate("/prediction");
  };

  const pieChartData = PredictionDetailResponse?.userPredictionSeats?.map(
    (item) => ({
      name: item?.["party.abbreviation"]?.toUpperCase(),
      value: parseFloat(parseFloat(item?.values).toFixed(2)),
      seat: parseFloat(parseFloat(item?.values).toFixed(2)),
      color: item?.["party.color_code"],
    })
  );

  const tableTransformedData = useMemo(() => {
    return (
      PredictionDetailResponse?.predictionArray?.map((item) => ({
        partyId: item?.partyId,
        categoryId: item?.voter_category_Id,
        value: item?.values,
      })) || []
    );
  }, [PredictionDetailResponse]);

  useEffect(() => {
    if (tableTransformedData.length > 0) {
      setTableData(tableTransformedData);
    }
  }, [tableTransformedData]);

  useEffect(() => {
    if (UpdatePredictionResponse?.msg !== undefined) {
      alert(UpdatePredictionResponse?.msg);
      dispatch(resetPollFields());
    }
  }, [UpdatePredictionResponse]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    const stateId =
      PredictionDetailResponse?.predictionArray?.[0]?.["state.id"];
    const countryId =
      PredictionDetailResponse?.predictionArray?.[0]?.["country.id"];

    const payload = {
      country: countryId,
      ...(stateId && { state: stateId }),
    };

    dispatch(getPartyList(payload));
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    submitUserPredictionById();
  };

  const handleChange = (categoryId, partyId, newValue) => {
    let newIntValue = parseInt(newValue.replace("%", ""), 10) || 0;
    setTableData((prevTableData) => {
      return prevTableData.map((entry) => {
        if (entry.categoryId === categoryId && entry.partyId === partyId) {
          const category = data.find((cat) => cat.id === categoryId);
          const total = prevTableData
            .filter((item) => item.categoryId === categoryId)
            .reduce(
              (sum, item) =>
                sum + (item.partyId === partyId ? newIntValue : item.value),
              0
            );

          // Validation logic
          if (
            category?.category?.toLowerCase() === "seats" &&
            total > PartyListResponse?.stateAndConstituencyData?.no_of_seats
          ) {
            alert(
              `Seats count cannot exceed ${PartyListResponse?.stateAndConstituencyData?.no_of_seats}!`
            );
            return entry;
          } else if (
            category?.category?.toLowerCase() !== "seats" &&
            total > 100
          ) {
            alert("values cannot exceed 100%!");
            return entry;
          }
          return { ...entry, value: newIntValue };
        }
        return entry;
      });
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = [];

    tableData.forEach((row) => {
      const category = data.find((cat) => cat.id === row.categoryId);
      const total = tableData
        .filter((entry) => entry.categoryId === row.categoryId)
        .reduce((sum, entry) => sum + (parseFloat(entry.value) || 0), 0);

      if (category?.category?.toLowerCase() === "seats") {
        // If category is "seats", limit to no_of_seats
        if (total > PartyListResponse?.stateAndConstituencyData?.no_of_seats) {
          errors.push(row.categoryId);
          console.log("🚀 ~ handleSubmit ~ errors:", errors)
        }
      } else {
        // Otherwise, limit to 100%
        if (total > 100) {
          errors.push(row.categoryId);
          console.log("🚀 ~ handleSubmit ~ errors:", errors)
        }
      }
    });

    setRowErrors(errors);

    if (errors.length > 0) {
      alert("Values exceed the limit! Please adjust them before submission.");
      return;
    }

    // Proceed with submission
    const formattedData = {
      id: params?.id,
      predictionArray: tableData,
    };

    dispatch(updateUserPrediction(formattedData)).then(() => {
      submitUserPredictionById();
    });

    setOpen(false);
  };
  const handleCompare = (event) => {
    const { name, checked } = event.target;

    setCompare((prev) => ({
      ...prev,
      payload: checked
        ? [...prev.payload, name]
        : prev.payload.filter((item) => item !== name),
    }));
  };
  const predictionbuttonArray = [
    // { label: "Completed Predictions", path: "" },
    { label: "My Live Predictions", path: "/prediction" },
    { label: "Followed Predictions", path: "/prediction/followed_prediction" },
    // { label: "New Prediction", handleClick: handleNewPrediction },
    // { label: "Followed Profiles", path: "" },
  ];

  const [transformedData, setTransformedData] = useState([]);
  const [uniquePartyIds, setUniquePartyIds] = useState([]);
  const [partyColors, setPartyColors] = useState({});
  const [partyAbbreviations, setPartyAbbreviations] = useState({});

  useEffect(() => {
    if (
      PredictionDetailResponse?.bestPollster ||
      PredictionDetailResponse?.averagePollster
    ) {
      const combineData = {
        userPrediction:
          PredictionDetailResponse?.userPredictionVoteshares || [],
        bestPollster: PredictionDetailResponse?.bestPollster || [],
        averagePollster: PredictionDetailResponse?.averagePollster || [],
      };
      // 🔹 Get all unique party IDs
      const allPartyIds = [
        ...new Set([
          ...combineData.userPrediction.map((d) => d.partyId),
          ...combineData.bestPollster.map((d) => d.partyId),
          ...combineData.averagePollster.map((d) => d.partyId),
        ]),
      ];

      // Set party colors
      const partyColorsMap = {};
      [
        ...combineData.userPrediction,
        ...combineData.bestPollster,
        ...combineData.averagePollster,
      ].forEach((d) => {
        if (d.partyId && d?.["party.color_code"]) {
          partyColorsMap[d.partyId] = d?.["party.color_code"];
        }
      });
      setPartyColors(partyColorsMap);

      const newPartyAbbreviations = {};
      [
        ...combineData.userPrediction,
        ...combineData.bestPollster,
        ...combineData.averagePollster,
      ].forEach((d) => {
        newPartyAbbreviations[d.partyId] =
          d?.["party.abbreviation"].toUpperCase() || "N/A";
      });

      // 🔹 Ensure each object has every party ID (Default to 0 if missing)
      const ensureKeys = (name, data) => {
        let obj = { name };
        allPartyIds.forEach((partyId) => {
          obj[partyId] = data.find((d) => d.partyId === partyId)?.values || 0;
        });
        return obj;
      };

      // 🔹 Transform Data
      const chartData = [
        ensureKeys("My Prediction", combineData.userPrediction),
        ensureKeys("Best Pollster", combineData.bestPollster),
        ensureKeys("Average Pollster", combineData.averagePollster),
      ];

      setTransformedData(chartData);
      setUniquePartyIds(allPartyIds);
      setPartyAbbreviations(newPartyAbbreviations);
      // console.log("Updated Transformed Data:", chartData);
      setTimeout(() => {
        window.scrollBy({
          top: 500, // Adjust this value based on how much you want to scroll
          behavior: "smooth", // Smooth scrolling effect
        });
      }, 500);
    } else {
      setTransformedData([]);
      return;
    }
  }, [PredictionDetailResponse]);

  // console.log(
  //   "Final Transformed Data:",
  //   JSON.stringify(transformedData, null, 2)
  // );

  const { prediction, setPrediction } = useContext(PredictionContext);
  const submitUserPredictionById = () => {
    dispatch(
      getUserPredictionById({ id: params?.id, payload: ["copy-averages", "copy-best"] })
    );
    // setCompare({
    //   show: false,
    //   payload: [],
    // });

    setCompare((prev) => ({
      ...prev,
      show: false,
    }));
  };

  const iscompares = () => {
    if (PredictionDetailResponse?.chartData.length > 0) {
      setIsCompare(true);

      // Delay ensures DOM is updated before scrolling
      setTimeout(() => {
        window.scrollBy({
          top: 500, // scroll down 200px (change as needed)
          behavior: "smooth",
        });
      }, 200);
    } else {
      setIsCompare(false);
    }
  };


  const handleApplyFilter = () => {
    if (compare.payload.length > 0) {
      submitUserPredictionById();
    } else {
      alert("Please select atleast 1 value");
    }
  };

  // console.log("params?.id", params?.id);

  const handleNavigate = (path, label) => {
    if (path) {
      if (label === "Followed Predictions" || "New Prediction") {
        navigate(path);
      }
      // else {
      //   window.location.reload();
      // }
    }
  };

  useEffect(() => {
    if (!isVerified) {
      navigate("/login");
    }
    checkComaprisionsAvailability();
    submitUserPredictionById();
  }, []);
  const handleXaxislabel = (value, index) => {
    return index % 4 === 0 ? value : "";
    // if (index < 5) {
    //   return index % 4 === 0 ? value : "";
    // } else if (index % 3 === 0) {
    //   return value;
    // } else return "";
  };

  const handlePayloadName = (name) => {
    if (name === "Best Pollster") {
      return "copy-best";
    } else if (name === "Average Pollster") {
      return "copy-averages";
    }
    return name;
  };
  const combinedChartData =
    PredictionDetailResponse?.userPredictionVoteshares?.map((item, idx) => {
      console.log("🚀 ~ MyPredictions ~ PredictionDetailResponse?.userPredictionSeats?.[idx]?.seat:", PredictionDetailResponse?.userPredictionSeats?.[idx])
      return {
        party: item.party_name || item.party || item.name,
        voteShare: Number(item?.values) || 0,
        seats: Number(
          PredictionDetailResponse?.userPredictionSeats?.[idx]?.values
        ) || 0,
        color: item?.["party.color_code"] || "#8884d8",
      };
    }) || [];
  useEffect(() => {
    console.log("🚀 ~ MyPredictions ~ PredictionDetailResponse?.voterCategory:", PredictionDetailResponse?.voterCategory)

    if (
      PredictionDetailResponse &&
      PredictionDetailResponse?.voterCategory?.length > 0
    ) {
      const formattedData = PredictionDetailResponse?.voterCategory?.map(
        (item) => ({
          category: item?.name,
          id: item?.id,
        })
      );
      setData(formattedData);
    }
  }, [PredictionDetailResponse]);
  const pageUrl = `https://pp.extcons.xyz/prediction/my_predictions/${params?.id}`;
  return (
    <>
      <Helmet>
        <meta property="og:title" content={"Delhi election Prediction"} />
        <meta
          property="og:image"
          content={
            "https://oar.blr1.cdn.digitaloceanspaces.com/UAT/images/17367719023040_istockphoto_1644251841_612x612_jpg.jpg"
          }
        />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="bg_home flex flex-col pb-8 h-auto">
        <div className="bg_home md:bg-[#F7F8FA] px-4 min-[955px]:px-40 flex flex-col pb-6 md:py-5 h-auto">
          <div className="p-2 md:p-5 bg-white  rounded-xl shadow-md">
            <div className="">
              <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 justify-start gap-1 md:gap-4 items-center">
                {predictionbuttonArray?.map((label, index) => {
                  return (
                    <div
                      key={index}
                      className={` text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center my-2 md:my-0 max-w-[15rem] ${label?.label === "My Live Predictions" &&
                        "bg-[#E4002B] text-white"
                        } ${label?.label === "New Prediction" &&
                        "bg-[#012169] text-white"
                        }`}
                      onClick={() =>
                        label?.handleClick
                          ? label?.handleClick()
                          : handleNavigate(label?.path, label?.label)
                      }
                    >
                      <img
                        src={
                          label?.label === "My Live Predictions" ||
                            label?.label === "New Prediction"
                            ? whiteCharticon
                            : charticon
                        }
                        alt="chart-icon"
                        width={12}
                      />
                      {label?.label}
                    </div>
                  );
                })}
                <div className="col-span-3  flex justify-end">
                  <div
                    className={`text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center max-w-[15rem] bg-[#012169] text-white`}
                    onClick={handleNewPrediction}
                  >
                    <img src={whiteCharticon} alt="chart-icon" width={12} />
                    New Prediction
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div className="my-4 text-[12px] text-[#7F8FA4] flex">
                {prediction?.selectCountry?.name && (
                  <div className="">{prediction?.selectCountry?.name}</div>
                )}
                {prediction?.electionTypeData?.type &&
                  prediction?.predictionTitle && (
                    <div className="mx-1">
                      {`> ${prediction?.electionTypeData?.type
                        }  > ${toTitleCase(prediction?.predictionTitle).replace(
                          "_",
                          " "
                        )}`}{" "}
                    </div>
                  )}
                {prediction?.freshPredict && (
                  <div className="mx-1">{`> Fresh/New Prediction > My Prediction`}</div>
                )}
              </div>
            </div>

            {!PredictionDetailResponse?.isPublish && (
              <div className="sm:flex justify-between items-center mb-4">
                <div className="flex gap-2 text-[14px] relative">
                  <button
                    className="px-4 py-2 border rounded-xl text-white bg-[#012169]"
                    onClick={handleOpen}
                  >
                    Edit
                  </button>
                  {/* {PredictionDetailResponse?.userPredictionVoteshares?.length >
                    0 ||
                    (PredictionDetailResponse?.userPredictionSegment?.length >
                      1 &&
                      (availableComaprisions.best ||
                        availableComaprisions.average) && (
                        <button
                          className="px-4 py-2 border rounded-xl text-white bg-[#012169]"
                          onClick={() =>
                            setCompare((prev) => ({
                              ...prev,
                              show: !compare.show,
                              payload: [],
                            }))
                          }
                        >
                          Compare
                        </button>
                      ))} */}
                  <button
                    className="px-4 py-2 border rounded-xl text-white bg-[#012169]"
                    onClick={() => iscompares()}
                  >
                    Compare
                  </button>
                  {/* {((PredictionDetailResponse?.userPredictionVoteshares?.length > 0 ||
                    (PredictionDetailResponse?.userPredictionSegment?.length > 1 ))&&
                      (availableComaprisions.best || availableComaprisions.average)) && (
                      <>
                        {console.log(
                          "Segment > 1:",
                          PredictionDetailResponse?.userPredictionSegment?.length > 1
                        )}
                        {console.log(
                          "VoteShares > 0:",
                          PredictionDetailResponse?.userPredictionVoteshares?.length > 0
                        )}

                        <button
                          className="px-4 py-2 border rounded-xl text-white bg-[#012169]"
                          onClick={() =>
                            setCompare((prev) => ({
                              ...prev,
                              show: !compare.show,
                              payload: [],
                            }))
                          }
                        >
                          Compare
                        </button>
                      </>
                    )}
                  {compare.show && (
                    <div
                      ref={compareRef}
                      className="absolute w-44 bg-[#F1F3F4] rounded-xl top-[42px] z-10 p-3 text-[12px] space-y-2 shadow-md"
                    >
                      {[
                        availableComaprisions?.best && {
                          id: "copy-best",
                          label: "Best Pollster",
                        },
                        availableComaprisions?.average && {
                          id: "copy-averages",
                          label: "Average Pollsters",
                        },
                      ]
                        .filter(Boolean)
                        .map((item) => (
                          <div
                            key={item.id}
                            className="flex items-center space-x-2"
                          >
                            <input
                              type="checkbox"
                              id={item.id}
                              name={item.id}
                              className="appearance-none w-4 h-4 border border-black rounded-sm checked:bg-black checked:border-black checked:after:content-['✔'] checked:after:text-white checked:after:text-[10px] checked:after:flex checked:after:items-center checked:after:justify-center"
                              onClick={handleCompare}
                            />
                            <label htmlFor={item.id} className="cursor-pointer">
                              {item.label}
                            </label>
                          </div>
                        ))}
                      <div className="flex justify-center mt-3">
                        <button
                          className="px-4 py-1 bg-[#E4002B] text-white rounded-xl"
                          onClick={handleApplyFilter}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )} */}
                  {/* <button className="px-4 py-2 bg-[#4252A8] text-white rounded-xl">
                  Compare
                </button> */}
                </div>
              </div>
            )}
            {/* Responsive Title */}
            {PredictionDetailResponse?.userPredictionVoteshares?.length > 1 && (
              <div className="text-start mb-2 flex-none ">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#333]">
                  Vote Share
                </h2>
              </div>
            )}
            <div className="flex flex-col md:flex-row items-center justify-center gap-6 w-full">
              {/* Bar Chart */}
              {/* {PredictionDetailResponse?.userPredictionVoteshares?.length >
                0 && (
                  <div
                    className={`${PredictionDetailResponse?.userPredictionSeats?.length > 0
                      ? "w-full"
                      : "w-full"
                      } flex justify-center`}
                  >
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart
                        data={transformedVoteShareData}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Bar
                          dataKey="value"
                          fill="#8884d8"
                          barSize={40}
                          name="Vote Share"
                        >
                          {transformedVoteShareData?.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry?.color} />
                          ))}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                )} */}
              {/* Pie Chart */}
              {/* {PredictionDetailResponse?.userPredictionSeats?.length > 1 && (
                <div className="w-full md:w-1/2 flex justify-center">
                  <PieChart width={642} height={330}>
                    <Pie
                      data={pieChartData}
                      cx={300}
                      cy={140}
                      innerRadius={80}
                      outerRadius={135}
                      fill="#8884d8"
                      paddingAngle={5}
                      labelLine={false}
                      dataKey="value"
                      label={({
                        cx,
                        cy,
                        midAngle,
                        innerRadius,
                        outerRadius,
                        index,
                      }) => {
                        const RADIAN = Math.PI / 180;
                        const radius =
                          innerRadius + (outerRadius - innerRadius) * 1.1;
                        const x = cx + radius * Math.cos(-midAngle * RADIAN);
                        const y = cy + radius * Math.sin(-midAngle * RADIAN);
                        const sliceData = pieChartData[index];
                        return (
                          <g>
                            {sliceData?.seat > 0 && (
                              <circle
                                cx={x}
                                cy={y - 1}
                                r={25}
                                fill="red"
                                stroke="white"
                                strokeWidth={4}
                              />
                            )}
                            {sliceData?.seat > 0 && (
                              <text
                                x={x}
                                y={y - 1}
                                fill="white"
                                textAnchor="middle"
                                dominantBaseline="central"
                                style={{ fontSize: "14px", fontWeight: "bold" }}
                              >
                                {`${sliceData?.seat}`}
                              </text>
                            )}
                          </g>
                        );
                      }}
                    >
                      {pieChartData?.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry?.color} />
                      ))}
                    </Pie>
                    <Tooltip />
                    <text
                      x={305}
                      y={150}
                      textAnchor="middle"
                      dominantBaseline="central"
                      style={{
                        fontSize: "21px",
                        fontWeight: "bold",
                        fill: "#333",
                      }}
                    >
                      SEATS
                    </text>
                  </PieChart>
                </div>
              )} */}
              {combinedChartData.length > 1 && (
                <div className="w-full mt-10">
                  <ResponsiveContainer width="100%" height={420}>
                    <BarChart
                      data={combinedChartData}
                      margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />

                      <XAxis
                        dataKey="party"
                        tick={{ fontSize: 11 }}
                        interval={0}
                        angle={-35}
                        textAnchor="end"
                      />

                      <YAxis yAxisId="left" tickFormatter={(v) => `${v}%`} />
                      <YAxis yAxisId="right" orientation="right" />

                      <Tooltip />
                      <Bar yAxisId="left" dataKey="voteShare" name="Vote Share (%)" barSize={30}>
                        {combinedChartData.map((entry, idx) => (
                          <Cell key={idx} fill={entry.color} />
                        ))}
                      </Bar>
                      <Bar yAxisId="right" dataKey="seats" name="Seats Won" barSize={30}>
                        {combinedChartData.map((entry, idx) => (
                          <Cell key={idx} fill={entry.color} opacity={0.6} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
            </div>
            {/* <CustomLegend /> */}
            {/* Bar Chart */}
            {/* {PredictionDetailResponse?.userPredictionSegment?.length > 1 && (
              <div
                className={`${
                  PredictionDetailResponse?.userPredictionSeats?.length > 1
                    ? "w-full "
                    : "w-full"
                } flex justify-center`}
              >
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    data={transformedSegmentData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="category"
                      // tickCount={28}
                      tickFormatter={
                        (value, index) => (index % 2 === 0 ? value : "")
                        // handleXaxislabel
                        // index % 4 === 0 ? value : value
                      }
                      tick={{ fontSize: 11 }}
                    />
                    <YAxis />
                    <Tooltip
                      formatter={(value, name, props) => [
                        `${value}`,
                        props.payload.name,
                      ]}
                    />
                    <Bar dataKey="value" barSize={40}>
                      {transformedSegmentData?.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={entry?.color}
                          name={entry?.name}
                        />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            )} */}

            {/* <SegmentComparisonChart
              userPredictionSegment={
                PredictionDetailResponse?.userPredictionSegment || []
              }
              bestPollsterSegment={PredictionDetailResponse?.bestPollster || []}
              averagePollsterSegment={
                PredictionDetailResponse?.averagePollster || []
              }
              voterCategoryList={PredictionDetailResponse?.voterCategory || []}
              comparePayload={compare.payload}
            /> */}

            {/* Bar Chart */}
            {iscompare && PredictionDetailResponse?.chartData && (
              <>
                <div className="my-3 text-[21px] font-bold text-[#333]">
                  Compared Result - Vote Share
                </div>

                <div className="w-full flex justify-center">
                  <ResponsiveContainer width="100%" height={390}>
                    <BarChart
                      data={[
                        {
                          group: "Your Prediction",
                          ...Object.fromEntries(
                            PredictionDetailResponse?.chartData.map((p) => [
                              p.name,
                              p.userPrediction,
                            ])
                          ),
                        },
                        {
                          group: "Best Pollster",
                          ...Object.fromEntries(
                            PredictionDetailResponse?.chartData.map((p) => [
                              p.name,
                              p.bestPollster || 0
                            ])
                          ),
                        },
                        {
                          group: "Average Pollster",
                          ...Object.fromEntries(
                            PredictionDetailResponse?.chartData.map((p) => [
                              p.name,
                              p.averagePollster || 0
                            ])
                          ),
                        },
                      ]}
                      margin={{ top: 20, right: 30, left: 10, bottom: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="group" tick={{ fontSize: 13 }} />
                      <YAxis />
                      <Tooltip />

                      {/* Dynamic bars for each party */}
                      {PredictionDetailResponse?.chartData.map((party) => (
                        <Bar
                          key={party.name}
                          dataKey={party.name}
                          name={party.name.toUpperCase()}
                          fill={party.colorCode}
                          barSize={45}
                        />
                      ))}
                    </BarChart>
                  </ResponsiveContainer>

                </div>
                 <div className="my-3 text-[21px] font-bold text-[#333]">
                  Compared Result - Seats
                </div>
                <div className="w-full flex justify-center mt-5">
                  <ResponsiveContainer width="100%" height={390}>
                    <BarChart
                      data={
                        PredictionDetailResponse?.chartSetsData
                          ? [
                            {
                              group: "Your Prediction",
                              ...Object.fromEntries(
                                PredictionDetailResponse.chartSetsData.map((p) => [
                                  p.name,
                                  p.userPredictionSeats ?? 0,
                                ])
                              ),
                            },
                            {
                              group: "Best Pollster",
                              ...Object.fromEntries(
                                PredictionDetailResponse.chartSetsData.map((p) => [
                                  p.name,
                                  p.bestSeats ?? 0,
                                ])
                              ),
                            },
                            {
                              group: "Average Pollster",
                              ...Object.fromEntries(
                                PredictionDetailResponse.chartSetsData.map((p) => [
                                  p.name,
                                  p.averageSeats ?? 0,
                                ])
                              ),
                            },
                          ]
                          : []
                      }
                    >
                      <XAxis dataKey="group" />
                      <YAxis unit="%" />
                      <Tooltip formatter={(val) => `${val}%`} />

                      {PredictionDetailResponse?.chartSetsData.map((party) => (
                        <Bar
                          key={party.name}
                          dataKey={party.name}
                          fill={party.colorCode}
                          barSize={45}
                        />
                      ))}
                    </BarChart>
                  </ResponsiveContainer>

                </div>
              </>
            )}

            {/* {legendData?.length > 0 && <CustomLegend />} */}
            {legendData?.length < 1 && <CustomVoteShareLegend />}
          </div>
        </div>

        <Modal open={open} onClose={handleClose}>
          <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-4 sm:p-6 rounded-lg shadow-lg w-[95vw] max-w-[1200px]">
            <div className="flex justify-between items-center flex-wrap gap-2">
              <p className="text-[18px] font-semibold mb-4">Edit Predictions</p>
              <button
                className="text-[14px] text-white mb-4 bg-[#5F6368] px-5 py-2 rounded-xl"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
            <form className="flex flex-col gap-2 border-2 rounded-2xl p-3 overflow-x-auto">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse text-[14px] min-w-[600px]">
                  <thead>
                    <tr className="text-left">
                      <th className="p-2 min-w-[10rem]"> </th>
                      {PartyListResponse?.partyData?.map((party) => (
                        <th key={party?.id} className="p-2">
                          {party?.abbreviation?.toUpperCase()}
                        </th>
                      ))}
                      <th className="p-2">Contribution</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((row, index) => {
                      const total = tableData
                        .filter((entry) => entry.categoryId === row.id)
                        .reduce(
                          (sum, entry) => sum + (parseFloat(entry.value) || 0),
                          0
                        );

                      const isSeatsCategory =
                        row.category.toLowerCase() === "seats";
                      const maxLimit = isSeatsCategory
                        ? PartyListResponse?.stateAndConstituencyData
                          ?.no_of_seats
                        : 100;
                      const exceedsLimit = total > maxLimit;

                      return (
                        <tr
                          key={row.id}
                          className={`${exceedsLimit
                            ? "bg-red-500"
                            : index % 2 === 0
                              ? "bg-[#FCF3F0]"
                              : "bg-[#E7F7FD]"
                            }`}
                        >
                          <td className="py-2 px-4 font-semibold">
                            {row?.category.toUpperCase()}
                          </td>

                          {PartyListResponse?.partyData?.map((field) => (
                            <td key={field.id} className="p-2">
                              <input
                                type="text"
                                value={
                                  tableData?.find(
                                    (entry) =>
                                      entry.categoryId === row.id &&
                                      entry.partyId === field.id
                                  )?.value
                                }
                                className="w-[4rem] sm:w-[5rem] md:w-[6rem] text-center p-1 rounded"
                                onChange={(e) =>
                                  handleChange(row.id, field.id, e.target.value)
                                }
                              />
                            </td>
                          ))}

                          <td className="p-2">
                            <input
                              type="text"
                              disabled
                              value={`${total}${!isSeatsCategory ? "%" : ""}`}
                              className="w-[4rem] sm:w-[5rem] md:w-[6rem] text-center p-1 rounded font-semibold bg-[#DCDFE3]"
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="flex justify-end gap-2 mt-4 flex-wrap">
                <button
                  className="text-[14px] text-white bg-[#4252A8] px-5 py-2 rounded-xl"
                  onClick={handleSubmit}
                >
                  Update
                </button>
              </div>
            </form>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default MyPredictions;
